import { FormsService } from "../../../services/forms/forms.service";
import { AuthStripeUserRequestActionType } from "../types";

export function* authStripeUserSaga({ payload }: AuthStripeUserRequestActionType) {
    try {
        const {
            data: { data },
        } = yield FormsService.getPaymentStripeAuthURL();
        window.open(data, "_self");
    } catch (error) {
        console.log("Stripe Auth Error", error);
        // yield put(Handle Error);
    }
}
